



















































































/* eslint-disable @typescript-eslint/camelcase */
import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import dayjs from 'dayjs'
import { generateReport, PaymentsDataExportFormats, ReportType } from '@/services/reports'

@Component
export default class ExportDataDialog extends Vue {
  @Prop({ default: false }) readonly opened!: boolean

  downloadStarted = false
  today = dayjs().format('YYYY-MM-DD')
  dateRange = [
    dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
    this.today,
  ]
  format: PaymentsDataExportFormats = PaymentsDataExportFormats.XLSX
  reportType: ReportType = ReportType.Payments
  
  @Watch('opened')
  onOpened(newVal: boolean) {
    if (newVal) {
      this.downloadStarted = false
    }
  }

  closeDialog() {
    this.$emit("update:opened", false)
  }

  exportFormats: any = [
    {
      name: PaymentsDataExportFormats.XLSX,
      icon: 'mdi-microsoft-office',
      label: 'Excel spreadsheet',
    },
    // {
    //   name: PaymentsDataExportFormats.PDF,
    //   icon: 'mdi-file-pdf-box',
    //   label: 'Adobe PDF',
    // },
    {
      name: PaymentsDataExportFormats.CSV,
      icon: 'mdi-file-delimited-outline',
      label: 'Comma-separated values',
    },
    {
      name: PaymentsDataExportFormats.JSON,
      icon: 'mdi-code-json',
      label: 'Javascript object notation',
    },
  ]

  reportTypes: any = [
    {
      name: ReportType.Payments,
      label: 'Payments report',
    },
    {
      name: ReportType.Time,
      label: 'Attendance report',
    }
  ]

  async download() {
    this.downloadStarted = true
    await generateReport(
      this.reportType,
      this.dateRange[0],
      this.dateRange[1],
      this.format
    )
    setTimeout(() => {
      this.closeDialog()
    }, 1500)
  }
}
